module.exports = __webpack_public_path__ + "static/media/iconHome.1a95914c.svg";